export var features = [{
  id: 'return',
  label: 'Rentabilidad',
  tooltip: {
    title: 'Rentabilidad',
    text: 'Rentabilidad obtenida por el producto'
  }
}, {
  id: 'cost',
  label: 'Coste competitivo',
  tooltip: {
    title: 'Coste competitivo',
    text: 'Coste del producto comparado con los de su categoría.'
  }
}, {
  id: 'risk',
  label: 'Nivel de riesgo',
  tooltip: {
    title: 'Nivel de riesgo',
    text: 'Nivel de volatilidad o incertidumbre de la evolución de un activo establecido de 1 a 4.'
  }
}, {
  id: 'value-for-money',
  label: 'Calidad/precio',
  tooltip: {
    title: 'Relación calidad precio',
    text: 'Relación entre rentabilidad y coste a 3 años frente a otros productos similares.'
  }
}];